import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

const TRANSFORM_PATHS_0 = [
  { path: 'job.createdDate' },
  { path: 'job.updatedDate' },
];

function resolveWixInfraAsyncjobsV1AsyncJobServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/async-job-service',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/async-jobs',
        destPath: '/v1/async-jobs',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/async-jobs',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/async-jobs',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/async-jobs',
        destPath: '',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/_api/async-jobs',
        destPath: '',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_api/async-jobs',
        destPath: '',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_api/async-jobs',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/async-job-service',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/async-job-service',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/async-job-service',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_async-jobs_async-jobs';

/** Retrieves a job. */
export function getAsyncJob(payload: object): RequestOptionsFactory<any> {
  function __getAsyncJob({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.infra.asyncjobs.v1.async_job',
      method: 'GET' as any,
      methodFqn: 'wix.infra.asyncjobs.v1.AsyncJobService.GetAsyncJob',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixInfraAsyncjobsV1AsyncJobServiceUrl({
        protoPath: '/v1/async-jobs/{jobId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: TRANSFORM_PATHS_0,
          },
        ]),
    };

    return metadata;
  }

  return __getAsyncJob;
}

/** Retrieves a list of job items. */
export function listAsyncJobItems(payload: object): RequestOptionsFactory<any> {
  function __listAsyncJobItems({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.infra.asyncjobs.v1.async_job',
      method: 'GET' as any,
      methodFqn: 'wix.infra.asyncjobs.v1.AsyncJobService.ListAsyncJobItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixInfraAsyncjobsV1AsyncJobServiceUrl({
        protoPath: '/v1/async-jobs/{jobId}/items',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __listAsyncJobItems;
}
